"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MenuContentMixin = require("../../mixins/components/MenuContentMixin");
/**
 * The `Menu` component is usually limited to a list of `MenuItem` actions, but you can add brief
 * supporting text with this component.
 *
 * @since 7.28.0
 */
var MenuContent = /*#__PURE__*/_styledComponents.default.p.withConfig({
  displayName: "MenuContent",
  componentId: "c11n-8-100-7__sc-1zffre-0"
})(["", ""], _MenuContentMixin.MenuContentMixin);
exports.MenuContent = MenuContent;
MenuContent.displayName = 'MenuContent';
MenuContent.propTypes = {
  /**
   * Supporting menu text.
   */
  children: _propTypes.default.node.isRequired
};

/** @component */